const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'OkkiAutoCompleteOptGroup';
export default OptGroup;
